import { SiteConfig } from "./types/api/siteConfig";

export const baseSiteConfig: SiteConfig = {
  homePageDCOIn: "NE4",
  homePageDCOOut: "NE5",
};

export const saurYellow: string = "#FFCD00";
export const saurDarkBlue: string = "#0a3c5c";
